module.exports = __webpack_public_path__ + "static/assets/9d01a522f48d894b0cba75f572f128b3.svg";